var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDevOpsEngineer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 130 90",
    style: {
      enableBackground: "new 0 0 130 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#F37A3D;}\r\n\t.st1{fill:#4D5E80;}\r\n\t.st2{fill:#EC5436;}\r\n\t.st3{fill:#3D4B66;}\r\n\t.st4{fill:#F0E6E1;}\r\n\t.st5{fill:#F9F4F3;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M83.3,25.5l2.3-2.3l-3.1-3.1L75,27.6l7.5,7.5l3.1-3.1l-2.1-2.1c8,0.5,14.3,7.1,14.3,15.2 c0,8.5-6.9,15.3-15.3,15.3s-15.3-6.9-15.3-15.3c0-4.3,1.7-8.2,4.8-11.2l1.6-1.5l-3-3.2L69,30.8c-1.7,1.6-3,3.5-4,5.5 c-3.3-6.4-9.8-10.9-17.5-10.9c-10.9,0-19.9,8.8-19.9,19.7c0,5.4,2.4,10.6,6.3,14.4l1.6,1.5l3-3.2L37,56.3 c-3.1-2.9-4.8-6.9-4.8-11.2c0-8.5,6.9-15.3,15.3-15.3s15.3,6.9,15.3,15.3c0,8.1-6.3,14.7-14.3,15.2l2.1-2.1l-3.1-3.1L40,62.7 l7.5,7.5l3.1-3.1l-2.3-2.3C55.6,64.5,61.9,60.2,65,54c3.3,6.4,9.8,10.9,17.5,10.9c10.9,0,19.9-8.8,19.9-19.7 C102.4,34.6,93.8,26,83.3,25.5L83.3,25.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M54,45.1c0-0.4,0-0.8-0.1-1.2l2.2-1.3L54,38.9l-2.2,1.3c-0.6-0.5-1.3-0.9-2.1-1.2v-2.6h-4.4v2.6 c-0.8,0.3-1.5,0.7-2.1,1.2L41,38.9l-2.2,3.8l2.2,1.3c-0.1,0.4-0.1,0.8-0.1,1.2c0,0.4,0,0.8,0.1,1.2l-2.2,1.3l2.2,3.8l2.2-1.3 c0.6,0.5,1.3,0.9,2.1,1.2v2.6h4.4v-2.6c0.8-0.3,1.5-0.7,2.1-1.2l2.2,1.3l2.2-3.8l-2.2-1.3C54,46,54,45.6,54,45.1L54,45.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M83.3,25.5l2.3-2.3l-3.1-3.1L75,27.6l7.5,7.5l3.1-3.1l-2.1-2.1c8,0.5,14.3,7.1,14.3,15.2 c0,8.5-6.9,15.3-15.3,15.3s-15.3-6.9-15.3-15.3c0-4.3,1.7-8.2,4.8-11.2l1.6-1.5l-3-3.2L69,30.8c-1.7,1.6-3,3.5-4,5.5c0,0,0,0,0,0 V54c3.3,6.4,9.8,10.9,17.5,10.9c10.9,0,19.9-8.8,19.9-19.7C102.4,34.6,93.8,26,83.3,25.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M89.1,45.1c0-0.4,0-0.8-0.1-1.2l2.2-1.3L89,38.9l-2.2,1.3c-0.6-0.5-1.3-0.9-2.1-1.2v-2.6h-4.4v2.6 c-0.8,0.3-1.5,0.7-2.1,1.2L76,38.9l-2.2,3.8l2.2,1.3C76,44.3,76,44.7,76,45.1c0,0.4,0,0.8,0.1,1.2l-2.2,1.3l2.2,3.8l2.2-1.3 c0.6,0.5,1.3,0.9,2.1,1.2v2.6h4.4v-2.6c0.8-0.3,1.5-0.7,2.1-1.2l2.2,1.3l2.2-3.8L89,46.3C89.1,46,89.1,45.6,89.1,45.1L89.1,45.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 82.5,
    cy: 45.1,
    r: 2.2
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 47.5,
    cy: 45.1,
    r: 2.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevOpsEngineer);
export default __webpack_public_path__ + "static/media/DevOpsEngineer.8f3a2c800b5ef847d76ae740a70dbc2d.svg";
export { ForwardRef as ReactComponent };